import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import logo from "@/assets/logo.png";
import loginHero from "@/assets/login-hero.png";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      nav(u.role === "admin" ? "/admin" : (loc.state?.from || "/dashboard"));
    } catch (err) {
      toast.error(err.message);
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-2 mb-10" data-testid="brand-link">
            <img src={logo} alt="Pranav Anand Enterprises" className="h-14 w-auto object-contain"/>
            <span className="font-heading font-semibold text-base" style={{color:"#0e5a32"}}>Pranav Anand Enterprises</span>
          </Link>
          <h1 className="text-3xl font-heading font-semibold tracking-tight mb-2" data-testid="login-title">Sign in</h1>
          <p className="text-sm text-gray-500 mb-8">Use your account to place orders and view invoices.</p>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-xs font-medium uppercase tracking-wider text-gray-600">Email</Label>
              <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-sm mt-1"/>
            </div>
            <div>
              <Label htmlFor="password" className="text-xs font-medium uppercase tracking-wider text-gray-600">Password</Label>
              <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-sm mt-1"/>
              <div className="text-right mt-1.5">
                <Link to="/forgot-password" className="text-xs text-[#002fa7] hover:underline" data-testid="login-forgot-password">Forgot password?</Link>
              </div>
            </div>
            <Button type="submit" disabled={submitting} data-testid="login-submit" className="w-full bg-[#002fa7] hover:bg-[#00227b] rounded-sm">
              {submitting ? "Signing in…" : "Sign in"}
            </Button>
          </form>
          <p className="text-sm text-gray-500 mt-6">
            New here? <Link to="/register" className="text-[#002fa7] font-medium hover:underline" data-testid="login-to-register">Create an account</Link>
          </p>
        </div>
      </div>
      <div className="hidden md:block bg-[#e9f3f1]">
        <img
          src={loginHero}
          alt="Order hospitality and housekeeping supplies online"
          className="w-full h-full object-cover"
          data-testid="login-hero-image"
        />
      </div>
    </div>
  );
}
